import { useSnackbar } from 'notistack';
import { useAuth } from '../../../auth';
import HardwareRequestsForm from './HardwareRequestsForm';
import { createHardwareRequest } from '../../../services/hardwareService';

const HardwareRequestFormContainer = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { getToken } = useAuth();

  const handleSubmit = async ({ description, title }) => {
    try {
      const result = await createHardwareRequest(getToken, { title, description });

      if (result?.status !== 'OK') {
        throw new Error(result?.message || 'Request failed');
      }

      enqueueSnackbar('Hardware request successfully submitted', {
        variant: 'success',
      });
    } catch (err) {
      enqueueSnackbar(err.message || 'Error when submitting hardware request', {
        variant: 'error',
      });
      console.error('Hardware request submission failed: ', err);
    }
  };

  return <HardwareRequestsForm onSubmitButtonClick={handleSubmit} />;
};

export default HardwareRequestFormContainer;
